import React from "react";
import { Link, RouteComponentProps, Switch, Route } from "react-router-dom";
import { About } from "./About";
import { Credits } from "./Credits";
import { Privacy } from "./Privacy";
import { Trademark } from "./Trademark";

import DesignMuseumLogo from "./assets/images/logoDesignMuseum.svg";

import "./InfoModal.scss";

export const InfoModal: React.FC<RouteComponentProps> = ({ match }) => {
  return (
    <div className="infoModal">
      <Switch>
        <Route exact path={`${match.path}`} component={About} />
        <Route exact path={`${match.path}/privacy`} component={Privacy} />
        <Route exact path={`${match.path}/credits`} component={Credits} />
        <Route exact path={`${match.path}/trademark`} component={Trademark} />
      </Switch>
      <footer className="infoModalFooter">
        <div className="designMuseum">
          <a
            className="designMuseumLink"
            href="//designmuseum.org"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="designMuseumLogo"
              src={DesignMuseumLogo}
              alt="The Design Museum"
            />
          </a>
        </div>
        <Link to="/about">About</Link>
        <Link to="/about/privacy">Privacy</Link>
        <Link to="/about/credits">Credits</Link>
        <Link to="/about/trademark">Trademark</Link>
      </footer>
      <Link className="button button--close" to="/">
        <span className="sr-only">Close</span>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48">
          <rect
            x="-8.33"
            y="22.39"
            width="64.67"
            height="3.21"
            transform="translate(24 -9.94) rotate(45)"
          />
          <rect
            x="-8.33"
            y="22.39"
            width="64.67"
            height="3.21"
            transform="translate(57.94 24) rotate(135)"
          />
        </svg>
      </Link>
    </div>
  );
};
